import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class FinancialTypes {
  static myExtract: IActionType = new ActionType('FINANCIAL/LOAD_MY_EXTRACT');
  static myBlockedExtract: IActionType = new ActionType('FINANCIAL/LOAD_MY_BLOCKED_EXTRACT');
  static myFutureExtract: IActionType = new ActionType('FINANCIAL/LOAD_MY_FUTURE_EXTRACT');
  static extractItems: IActionType = new ActionType('FINANCIAL/LOAD_EXTRACT_ITEMS');
  static loadAvailable: IActionType = new ActionType('FINANCIAL/LOAD_AVAIABLE');
  static bankTransfer: IActionType = new ActionType('FINANCIAL/BANK_TRANSFER');
  static anticipationTransfer: IActionType = new ActionType('FINANCIAL/ANTICIPATION_TRANSFER');
  static listInvoicesAnticipation: IActionType = new ActionType('FINANCIAL/LIST_ANTICIPATION_INVOICES');
  static listTransfers: IActionType = new ActionType('FINANCIAL/LIST_TRANSFER');
  static loadFilterByMonth: IActionType = new ActionType('FINANCIAL/LOAD_FILTER_BY_MONTH');
  static filterExtract: IActionType = new ActionType('FINANCIAL/FILTER_EXTRACT');
  static infoMoneyReportTransfers: IActionType = new ActionType('FINANCIAL/INFOMONEY_TRANSFER_REPORT');
}

export default FinancialTypes;
